const ACTIVE_COUNT_UNAVAILABLE_KEY = 'hiromatch:active-count-unavailable';

export function isActiveCountEndpointUnavailable(companyId: string): boolean {
  try {
    return sessionStorage.getItem(`${ACTIVE_COUNT_UNAVAILABLE_KEY}:${companyId}`) === '1';
  } catch {
    return false;
  }
}

export function markActiveCountEndpointUnavailable(companyId: string): void {
  try {
    sessionStorage.setItem(`${ACTIVE_COUNT_UNAVAILABLE_KEY}:${companyId}`, '1');
  } catch {
    // private mode / quota
  }
}

export function clearActiveCountEndpointUnavailable(companyId: string): void {
  try {
    sessionStorage.removeItem(`${ACTIVE_COUNT_UNAVAILABLE_KEY}:${companyId}`);
  } catch {
    // ignore
  }
}
